export class CloudFile {
  fileName: string;
  fileUrl: any;
  fileType: string;
  description: string;
  createdByID: number;
  createdOn: Date;
  lastUpdateByID: number;
  lastUpdateTime: Date;
  loading: boolean;
  downloading: boolean;
  error: boolean;
  isAttachment?: boolean;
  size?: number;
}

export class Folder {
  folderName: string;
  files?: CloudFile[];
  subFolders?: Folder[];
}
